export default "__VITE_ASSET__DDRxAQKa__"